var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btnBox"},[_c('van-button',{staticClass:"cancel",attrs:{"type":"default","native-type":"button"},on:{"click":_vm.onClickLeft}},[_vm._v(" 取消 ")]),_c('van-button',{staticClass:"submit",class:_vm.disabled ? 'disabledSub' : '',attrs:{"type":"primary","disabled":_vm.disabled},on:{"click":_vm.submit}},[_vm._v(" 确定 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }